// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2nF4-","imageUploader":"EGiftCard_imageUploader__2JIUe"};